/* eslint-disable prettier/prettier */
import { Input } from 'app/components/ui/input';
import { Label } from 'app/components/ui/label';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'app/components/ui/select';

function Duration() {
  const form = useFormContext();

  const durationType = form.watch('duration_type') || '1';

  const handleChangeDurationType = value => {
    const resetFields = {
      1: ['expiry_date'],
      2: ['duration', 'duration_unit', 'expiry_date'],
      3: ['duration', 'duration_unit'],
    };

    // Reset fields based on the value
    if (resetFields[value]) {
      resetFields[value].forEach(field => form.setValue(field, null));
    }

    // Set the duration_type
    form.setValue('duration_type', value);
  };

  return (
    <>
      <div className="bg-white  dark:bg-transparent rounded-lg p-4 mb-6">
        <div>
          <div className="mb-4">
            <Label htmlFor="original-price">Course Duration Type </Label>
            <Select
              {...form.register('duration_type')}
              onValueChange={value => {
                handleChangeDurationType(value);
              }}
              value={durationType}
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Single Validity" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="1">Single Validity</SelectItem>
                <SelectItem value="2">Lifetime Validity</SelectItem>
                <SelectItem value="3">Course Expiry Date</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {durationType == 1 && (
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-6">
                <Input
                  id="duration"
                  type="text"
                  placeholder="Enter Duration"
                  {...form.register('duration', {
                    required: 'Duration is required',
                  })}
                />
              </div>
              <div className="col-span-6">
                <Select
                  {...form.register('duration_unit')}
                  defaultValue="years"
                  onValueChange={value => {
                    form.setValue('duration_unit', value);
                  }}
                >
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Day(s)" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="hours">Hour(s)</SelectItem>
                    <SelectItem value="days">Day(s)</SelectItem>
                    <SelectItem value="weeks">Week(s)</SelectItem>
                    <SelectItem value="months">Month(s)</SelectItem>
                    <SelectItem value="years">Year(s)</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          )}

          {durationType == 3 && (
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12">
                <Label htmlFor="expiry_date">Expiry Date</Label>
                <Input
                  id="expiry_date"
                  type="date"
                  placeholder="Enter Expiry Date"
                  {...form.register('expiry_date', {
                    required: 'Expiry Date is required',
                  })}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Duration;
